import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import curbsideAPIService from '../services/curbsideAPIService';
import { setAllowOrderCompletion, setAllowIDScanning } from './orderDetailsSlice';

// Async thunk for fetching order data
export const fetchOrderData = createAsyncThunk('orderInfo/fetchOrderData', async (orderId : string, {dispatch, rejectWithValue }) => {
  try {
    const response = await curbsideAPIService.get(`orders/${orderId}`);
    
    dispatch(setAllowOrderCompletion(response.allowCompletion));
    dispatch(setAllowIDScanning(response.allowIDScanning));
    return response;
  } catch (error) {
    console.error('Error fetching order data:', error);
    return rejectWithValue((error as any).response?.data ?? 'Failed to fetch order data');
  }
});

const orderInfoSlice = createSlice({
  name: 'orderInfo',
  initialState: {
    orderDetails: null,
    orderLog: [],
    loadOrderLogs: false,
    loading: false,
    error: null as string | null,
  },
  reducers: {
    setLoadOrderLogs: (state, action) => {
      return {
        ...state,
        loadOrderLogs: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderData.pending, (state) => {
        return {
          ...state,
          loading: true,
          error: null,
        };
      })
      .addCase(fetchOrderData.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          orderDetails: action.payload,
        };
      })
      .addCase(fetchOrderData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string | null;
      });
  },
});

export const { setLoadOrderLogs } = orderInfoSlice.actions;
export default orderInfoSlice.reducer;
